<template>
    <div class="container">
        <div class="mt-card-auth">
            <div class="card">
                <div class="card-body">
                    <div class="title text-center">
                        <div class="main-title">Abdi<span class="text-primary">Social</span></div>
                        <div class="sub-title mt-1">Masuk Akun</div>
                    </div>

                    <div class="mt-4">
                        <div class="alert alert-danger small" v-if="error.login">
                            <template v-if="error.login == 'error'">Terjadi kesalaham, silahkan coba lagi.</template>
                            <template v-else-if="error.login == 'email-not-exists'">Email tidak terdaftar.</template>
                            <template v-else-if="error.login == 'wrong-password'">Password salah.</template>
                        </div>

                        <div class="form-group">
                            <vs-input v-model="form.email" placeholder="Email" type="email">
                                <template #icon>
                                    <box-icon name="mail-send"></box-icon>
                                </template>
                            </vs-input>
                        </div>
                        <div class="form-group">
                            <vs-input v-model="form.password" placeholder="Password" type="password">
                                <template #icon>
                                    <box-icon name="lock"></box-icon>
                                </template>
                            </vs-input>
                        </div>

                        <div class="mt-4">
                            <vs-button block @click="signIn()" :loading="loading.login">Masuk</vs-button>
                            <div class="mt-2">
                                <vs-button block border @click="actionTo('register')" :loading="loading.login">Daftar</vs-button>
                            </div>

                            <div class="text-center mt-3 small">
                                Lupa password? <span class="text-primary" @click="actionTo('reset-password')">klik disini.</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase';
import { usersCollection } from '@/helpers/firebase';
import accountHelper from '@/helpers/account';

export default {
    data() {
        return {
            loading: {
                login: false,
            },
            form: {
                email: '',
                password: '',
            },
            error: {
                login: '',
            }
        }
    },
    methods: {
        actionTo(url) {
            this.$router.push({ path: url });
        },
        signIn() {
            this.loading.login = true;
            this.error.login = '';

            let account = this.form;
            if(account.email && account.password) {
                firebase.auth().signInWithEmailAndPassword(account.email, account.password).then(() => {
                    usersCollection.doc(account.email).get().then(doc => {
                        if(doc.data().email) {
                            accountHelper.saveToLocalStorage(doc.data());
                            
                            this.$router.push({ path: '/' });
                        } else {
                            this.error.login = 'error';
                            this.loading.login = false;
                        }
                    })
                }).catch(err => {
                    if(err.code == 'auth/invalid-email' || err.code == 'auth/user-not-found') {
                        this.error.login = 'email-not-exists';
                    } else if(err.code == 'auth/wrong-password') {
                        this.error.login = 'wrong-password';
                    } else {
                        this.error.login = 'error';
                    }

                    this.loading.login = false;
                });
            }
        }
    }
}
</script>

<style scoped>
@import '../../styles/auth.css';
</style>